import type { Skill } from "./db/skills";

export type SkillGate = {
  activeSkills: Skill[];
  offeredSkills: Skill[];
  allows(toolName: string): boolean;
};

export function activeSkillIds(pinnedSkillId: string | null | undefined, activatedSkillIds: string[] | undefined): Set<string> {
  return new Set([...(pinnedSkillId ? [pinnedSkillId] : []), ...(activatedSkillIds ?? [])]);
}

export function buildSkillGate(
  skills: Skill[],
  activeIds: Set<string>,
  toolPrefs: Record<string, boolean>,
): SkillGate {
  const ownedByAnySkill = new Set<string>();
  const allowedViaActiveSkill = new Set<string>();
  for (const s of skills) {
    for (const n of s.toolNames) {
      ownedByAnySkill.add(n);
      if (activeIds.has(s.id)) allowedViaActiveSkill.add(n);
    }
  }
  const offeredSkills = skills.filter((s) => s.autoActivate && !activeIds.has(s.id));
  return {
    activeSkills: skills.filter((s) => activeIds.has(s.id)),
    offeredSkills,
    allows(toolName) {
      if (toolName === "activate_skill") return offeredSkills.length > 0;
      if (ownedByAnySkill.has(toolName)) return allowedViaActiveSkill.has(toolName);
      return toolPrefs[toolName] === true;
    },
  };
}
